import React from "react";
import { CheckCircle2 } from "lucide-react";
import { PageBanner } from "../components/Shared";
import aboutImg from "../assets/images/slider/slider3.webp";
import "./InnerPages.css";

const AboutPage = () => {
  return (
    <>
      <PageBanner title="About IDPS Mahore" breadcrumb="About" />
      <section className="section">
        <div className="container grid-2">
          <img
            src={aboutImg}
            alt="About IDPS Mahore"
            className="inner-img"
          />
          <div>
            <h2 className="inner-heading">About Us</h2>
            <p className="inner-para">
              The International Delhi Public School, Mahore is a co-educational
              CBSE school. IDPS Mahore ensures an education with a holistic
              perspective where the development of a child's intellectual,
              emotional, social, physical, creative, and spiritual potential is
              ensured.
            </p>
            <p className="inner-para">
              Children blossom into fine young individuals, in the safe and
              caring haven of IDPS Mahore, ready to conquer the world. Our
              students are prepared not only to score marks but to become the
              kind of human beings that can contribute to making this world a
              better place.
            </p>
            <p className="inner-para">
              The purpose of education is to turn mirrors into windows and this
              is what we at IDPS Mahore strive to do.
            </p>
            <ul className="check-list">
              {[
                "Best Learning Environment in Mahore",
                "Indoor and Outdoor Activities for Holistic Development",
                "Highly Qualified and Experienced Teachers",
                "Focus on Creativity, Leadership, and Teamwork",
              ].map((t) => (
                <li key={t}>
                  <span className="check-list__icon"><CheckCircle2 size={17} /></span> {t}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutPage;
